export const checkLast10Minutes = (ts) => {
  if ((Date.now() - ts) / 1000 < 60000) return true;
  return false;
};

function addZero(n) {
  return (n < 10 ? '0' : '') + n;
}

export function timestampToDateAlert(ts) {
  var a = new Date(ts);
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = `${addZero(year)}-${addZero(month)}-${addZero(date)} ${addZero(
    hour
  )}:${addZero(min)}:${addZero(sec)}`;
  return time;
}

export function timestampToDate(ts) {
  var a = new Date(ts);
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var date = a.getDate();
  var hour = a.getHours() + 7;
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = `${addZero(year)}-${addZero(month)}-${addZero(date)} ${addZero(
    hour
  )}:${addZero(min)}:${addZero(sec)}`;
  return time;
}

export function timestampToDateWithoutSecond(ts) {
  var a = new Date(ts);
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var time = `${addZero(year)}-${addZero(month)}-${addZero(date)} ${addZero(
    hour
  )}:${addZero(min)}`;
  return time;
}

export function dateToTimestamp(string) {
  const dateStr = string.split(' ')[0];
  const timeStr = string.split(' ')[1];
  const ts = new Date(
    dateStr.split('-')[0],
    dateStr.split('-')[1] - 1,
    dateStr.split('-')[2],
    timeStr.split(':')[0],
    timeStr.split(':')[1],
    timeStr.split(':')[2]
  ).getTime();
  return ts;
}

export function dateToTimestampTimeline(string) {
  const dateStr = string.split(' ')[0];
  const timeStr = string.split(' ')[1];
  const ts = new Date(
    dateStr.split('-')[0],
    dateStr.split('-')[1] - 1,
    dateStr.split('-')[2],
    timeStr.split(':')[0],
    timeStr.split(':')[1],
    timeStr.split(':')[2]
  ).getTime();
  return ts;
}

export function timestampToDateExcel(ts) {
  var a = new Date(ts);
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var time = `_${addZero(year)}_${addZero(month)}_${addZero(date)}_${addZero(
    hour
  )}_${addZero(min)}`;
  return time;
}
